import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'
import { faCheck } from '@fortawesome/pro-regular-svg-icons'
import { TypographyStyles } from '@/styles'
import type { MessageThreadStatus } from './types'

export const STATUS_LABEL: Record<MessageThreadStatus, string> = {
  awaiting: 'Your turn',
  with_heard: 'With Heard',
  resolved: 'Resolved',
}

export const STATUS_COLOR: Record<MessageThreadStatus, 'green' | 'gray'> = {
  awaiting: 'green',
  with_heard: 'gray',
  resolved: 'gray',
}

interface StatusRowStyle {
  variant: TypographyStyles
  label: string
  icon?: IconDefinition
  row?: string
}

export const STATUS_ROW_STYLE: Record<MessageThreadStatus, StatusRowStyle> = {
  awaiting: {
    variant: TypographyStyles.LABEL_XS,
    label: 'text-orange-200',
    row: 'bg-orange-0',
  },
  with_heard: {
    variant: TypographyStyles.BODY_XS,
    label: 'font-medium text-neutral-500',
  },
  resolved: {
    variant: TypographyStyles.BODY_XS,
    label: 'font-medium text-neutral-500',
    icon: faCheck,
  },
}
